// @flow

import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import type { Node } from 'react';

const Li = styled.li`
  color: ${props => props.theme.text.dark};
  display: flex;
  font-size: 14px;
  justify-content: center;
  line-height: 2;
  margin-bottom: 0.15em;
  .ss-alert {
    vertical-align: middle;
  }
  > * {
    display: inline-block;
    padding: 0 0.25em;
    vertical-align: middle;
    width: 50%;
  }
  > span {
    text-align: right;
  }
  > strong {
    font-weight: ${props => props.soloItem ? 'normal' : 'bold'};
  }
  > strong, > div {
    text-align: left;
  }
  ${props => props.issue && css`
    color: ${props.theme.warning.color};
  `}
  @media (min-width: 375px) {
    line-height: 1.6;
    margin-bottom: 0.5em;
    select {
      font-size: 14px;
    }
  }
`;

type Value = ?(number | string);

type Props = {
  abbr?: string,
  component?: Node,
  issue: boolean,
  label: string,
  soloItem?: boolean,
  value?: Value,
  valueFunc?: (Value) => void
}

class SpecResultItem extends Component<Props> {

  static defaultProps = {
    issue: false,
    soloItem: false
  }

  renderValue = () => {
    if (this.props.component) {
      return this.props.component;
    }

    let value = this.props.value;
    let abbr = this.props.abbr;

    if (value != null) {
      if (this.props.valueFunc != null) {
        value = this.props.valueFunc(value);
      }

      if (!isNaN(value)) {
        value = Math.round(parseFloat(value) * 100) / 100;
      }
    }

    return (
      <strong>
        <span>{value || 'INVALID'}</span>
        <abbr>{value && abbr}</abbr>
      </strong>
    );
  }

  render() {
    return (
      <Li issue={this.props.issue} soloItem={this.props.soloItem}>
        <span>
          {this.props.issue && <span className="ss-alert"></span>}
          <span> {this.props.label} </span>
        </span>
        {this.renderValue()}
      </Li>
    );
  }

}

export default SpecResultItem;



// WEBPACK FOOTER //
// ./src/components/SpecResultItem.js